import { JmhzPpvState } from '@tymbe/schema/enums';
import classNames from 'classnames';
import useCollapse from 'react-collapsed';

import TyAsyncSelect from '../../../../../../components/inputs/TyAsyncSelect';
import TyDateInput from '../../../../../../components/inputs/TyDateInput';
import { TySelect } from '../../../../../../components/inputs/TySelect';
import styles from '../../../../../../components/TyAdvancedSearch/Components/TyAdvancedSearchCore.module.css';
import { labelsValues } from '../../../../../../components/TyAdvancedSearch/Libs/enums';
import {
  loadCompanyOptions,
  loadRegisteredTymberOptions,
} from '../../../../../../components/TyAdvancedSearch/Libs/loadOptions';
import { CzechContractType } from '@tymbe/legislatives/czechia/CzechContractType';

const documentTypeOptions = [
  { label: 'DPP', value: CzechContractType.DohodaOProvedeniPrace },
  { label: 'DPČ', value: CzechContractType.DohodaOPracovniCinnosti },
  { label: 'HPP', value: CzechContractType.HlavniPracovniPomer },
];

const stateOptions = [
  { label: 'Předběžný', value: JmhzPpvState.PRELIMINARY },
  { label: 'Zaregistrovaný', value: JmhzPpvState.REGISTERED },
  { label: 'Ukončený', value: JmhzPpvState.ENDED },
  { label: 'Přeskočený', value: JmhzPpvState.SKIPPED },
  { label: 'Zrušený', value: JmhzPpvState.CANCELED },
];

const Basic: React.FC = () => {
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({ defaultExpanded: true });

  return (
    <div>
      <div className={styles.triggerContainer}>
        <div {...getToggleProps()} className={styles.trigger}>
          <h2>Základní parametry</h2>
        </div>

        <div {...getToggleProps()} className={styles.trigger}>
          <div className={classNames(styles.triggerIcon, { [styles.triggerIconRotated]: isExpanded })} />
        </div>
      </div>

      <section {...getCollapseProps()}>
        <div className={styles.row}>
          <div>
            <h3>Datum od - do</h3>
            <TyDateInput
              name={labelsValues.dateFormatFrom.name}
              label={labelsValues.dateFormatFrom.label}
              className={styles.tyInputs}
            />
          </div>

          <div>
            <TyDateInput
              name={labelsValues.dateFormatTo.name}
              label={labelsValues.dateFormatTo.label}
              className={styles.tyInputs}
            />
          </div>
        </div>
        <div className={styles.row}>
          <div>
            <h3>Firma</h3>
            <TyAsyncSelect
              loadOptions={loadCompanyOptions}
              name={labelsValues.company.name}
              label={labelsValues.company.label}
              className={styles.tyInputs}
              isClearable
              isMulti
            />
          </div>
          <div>
            <h3>Tymber</h3>
            <TyAsyncSelect
              loadOptions={loadRegisteredTymberOptions}
              name={labelsValues.tymber.name}
              label={labelsValues.tymber.label}
              className={styles.tyInputs}
              isClearable
              isMulti
            />
          </div>
        </div>
        <div className={styles.row}>
          <div>
            <h3>Typ smlouvy</h3>
            <TySelect
              name="documentType"
              label="Typ smlouvy"
              className={styles.tyInputs}
              options={documentTypeOptions}
            />
          </div>
          <div>
            <h3>Stav</h3>
            <TySelect name="state" label="Stav" className={styles.tyInputs} options={stateOptions} />
          </div>
        </div>
      </section>
    </div>
  );
};

const Body: React.FC = () => (
  <div className={classNames(styles.container, '[&_[class^=ty]]:min-w-[230px]')}>
    <Basic />
  </div>
);

export default Body;
